export default __webpack_public_path__ + "static/media/stonky-demo.2d993834.gif";